import Result from "iotera-base/result";
import React, { useEffect, useState } from "react";
import ReactJsonTree from "react-json-tree";
import { connect } from "react-redux";
import { SizeMe } from "react-sizeme";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { domainIsTenant as dit } from "../../../../../routes/routes";

import { Tooltip, Zoom } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import { safeGet, safeGetWithType } from "iotera-base/json";
import { isInteger, isNone } from "iotera-base/object";

import { buildWBoundActions } from "../../../../../redux/ducks";

import {
  CustomTableCell,
  TablePaginationActionsWrapped,
} from "../../../../../custom/table";
import { WEBSERVICE_FETCH } from "../../../../../lib/components/Preference";
import { getWidthColumnByPercent } from "../../../../../lib/components/function";

import "bootstrap/dist/css/bootstrap.min.css";
import "../alternative-style.css";

import {
  formatDate,
  formatItemStringUObject,
  formatLabelUObject,
  formatValueTable,
  formatValueUObject,
  selectKeyUObject
} from "../function";

import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from "../../../../../lib/components/callbackGlobal";

const dropdownItems = ["25", "50", "100"];

// declare golbal variabel tablelast
const DEVICE_DATA_RPAYLOAD = "FETCH_DATA_rpayload";
const DEVICE_DATA_LATEST = "FETCH_DATA_LATEST";
const WKEY = "DEVICE_DATA_DETAIL_LATEST";
const wBoundActions = buildWBoundActions(WKEY);

const TabLatest = (props) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dropdownOpen, setDropdownopen] = useState(false);
  let [dropdownLabel, setDropdownLabel] = useState(25);
  const [dataUObject, setDataUObject] = useState({});
  const [dialogUObject, setDialogUObject] = useState(false);
  const [selectedKey, setSelectedKey] = useState();

  useEffect(() => {
    let _props = props;
    const domainIsTenant = dit(_props);
    let deviceId = safeGet(_props, ["match", "params", "id"]);
    let selected = safeGet(_props, "selected");
    let sensor = safeGet(selected, "sensor");
    let configtype = safeGet(selected, "configtype");
    let param = safeGet(selected, "param");
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      wparam: {
        ...domainIsTenant,
        type: WEBSERVICE_FETCH,
        path:
          "/fetch/web/device/ndata/" +
          deviceId +
          "?sensor=" +
          sensor +
          "&configtype=" +
          configtype +
          "&param=" +
          param +
          "&ndata=" +
          dropdownLabel,
      },
      wcallback: {
        started: function () {
          _props.cbLoading(true);
        },
        finished: function (id, result) {
          if (result.code === Result.HTTP.OK) {
            const responseResult = safeGetWithType(
              result,
              ["body", "response_result"],
              Result.UNKNOWN_ERROR
            );
            if (responseResult === Result.SUCCESS) {
              setData(safeGetWithType(result, ["body", "data"], []));
              _props.cbLoading(false);
            } else {
              _props.cbLoading(false);
            }
          } else {
            _props.cbLoading(false);
          }
        },
      },
    });
    return () => {
      // callback global
      unsetCallbackGlobal(_props);
      _props.wUnsetConfig({ key: WKEY });
    };
  }, []);

  useEffect(() => {
    let _props = props;
    const domainIsTenant = dit(_props);
    let deviceId = safeGet(_props, ["match", "params", "id"]);
    let refresh = safeGet(_props, ["refresh"]);
    // callback global
    setCallbackGlobal(_props);
    _props.wSetConfig({
      single_config: {
        [DEVICE_DATA_LATEST]: {
          wparam: {
            ...domainIsTenant,
            type: WEBSERVICE_FETCH,
            path: "/fetch/web/device/ndata/" + deviceId,
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ["body", "response_result"],
                  Result.UNKNOWN_ERROR
                );
                if (responseResult === Result.SUCCESS) {
                  setData(safeGetWithType(result, ["body", "data"], []));
                  if (refresh) {
                    _props.cbRefresh(false);
                  }
                  _props.cbLoading(false);
                } else {
                  if (refresh) {
                    _props.cbRefresh(false);
                  }
                  _props.cbLoading(false);
                }
              } else {
                if (refresh) {
                  _props.cbRefresh(false);
                }
                _props.cbLoading(false);
              }
            },
          },
          wenv: { params: "ndata" },
        },
      },
    });
    return () => {
      // callback global
      unsetCallbackGlobal(_props);
      _props.wUnsetConfig({ key: WKEY });
    };
  }, []);

  const toggle = () => {
    setDropdownopen((prevState) => !prevState);
  };

  const handleDropdownItem = (e) => {
    setDropdownLabel((dropdownLabel = parseInt(e.target.innerText)));
    const _props = props;
    let selected = safeGet(_props, "selected");
    let sensor = safeGet(selected, "sensor");
    let configtype = safeGet(selected, "configtype");
    let param = safeGet(selected, "param");
    _props.wSetEnv({
      type: "params",
      env: "ndata",
      value: {
        sensor: sensor,
        configtype: configtype,
        param: param,
        ndata: dropdownLabel,
      },
    });
    let deviceId = safeGet(_props, ["match", "params", "id"]);
    let wsKey = WKEY + "_" + deviceId;
    _props.cbLoading(true);
    _props.wSingleRequestCall({
      id: DEVICE_DATA_LATEST,
    });
  };

  const handleExpandNode = () => false;

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = (event) => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage)) rowsPerPage = parseInt(rowsPerPage);
    setPage(0);
    setRowsPerPage(rowsPerPage);
  };

  const handleClickUObject = (i, value) => (e) => {
    setDataUObject(value);
    setSelectedKey(i);
    setDialogUObject(true);
  };

  const handleCloseUObject = () => {
    setDialogUObject(false);
  };

  let subparamDatatypes = safeGet(props, ["selected", "subparam_datatypes"]);
  let _dataUObject = dataUObject;
  if (_dataUObject === null) {
    _dataUObject = {};
  }

  const shouldShowExpandanble = (dt, sdts) => {
    if (dt === 'uobject' || dt === 'image' || dt === 'mobject' || dt === 'surveillance') {
      return true;
    } else if (dt === 'object' && !isNone(sdts)) {
      for (let subparam in sdts) {
        const sdt = safeGet(sdts, subparam)
        if (sdt === 'uobject') {
          return true;
        }
      }
    }
    return false;
  }

  return (
    <div>
      <div className="d-flex justify-content-end">
        <Tooltip
          TransitionComponent={Zoom}
          title="Select amount of latest data"
          enterDelay={500}
          placement="left"
        >
          <div>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret>{dropdownLabel}</DropdownToggle>
              <DropdownMenu right className="p-0 m-0">
                {dropdownItems.map((dropdownItem, i) => (
                  <DropdownItem
                    key={i}
                    className="py-2 m-0 d-flex justify-content-center"
                    onClick={handleDropdownItem}
                  >
                    {dropdownItem}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </Tooltip>
      </div>
      <SizeMe>
        {({ size }) => (
          <div className="table-responsive mt-4">
            <Table className="table">
              <TableHead style={{ height: 0 }}>
                <TableRow>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(60, size.width - 140),
                      maxWidth: getWidthColumnByPercent(60, size.width - 140),
                    }}
                  >
                    value
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    quality
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    updated
                  </CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => (
                    <TableRow key={i} className="table-row-child-iotera">
                      <TableCell>
                        {shouldShowExpandanble(item.dt, subparamDatatypes) ? (
                          <Button
                            onClick={handleClickUObject(
                              i,
                              safeGet(item, "value"),
                              {}
                            )}
                          >
                            {" "}
                            {`{...}`}{" "}
                          </Button>
                        ) : (
                          formatValueTable(true, item.dt, item.value, subparamDatatypes)
                        )}
                        {i === selectedKey ? (
                          <Dialog
                            open={dialogUObject}
                            onClose={handleCloseUObject}
                            aria-labelledby="uobject-latest-dialog-title"
                            aria-describedby="uobject-latest-dialog-description"
                            fullWidth={true}
                            maxWidth={"md"}
                          >
                            <DialogTitle id="uobject-latest-dialog-title">
                              {" "}
                              {`${item.sensor}:${item.configtype}:${item.param}`}{" "}
                            </DialogTitle>
                            <DialogContent className="dialog-content-uobject">
                              <ReactJsonTree
                                data={_dataUObject}
                                theme={{
                                  tree: ({ style }) => ({
                                    style: {
                                      ...style,
                                      backgroundColor: undefined,
                                    }, // removing default background color from styles
                                  }),
                                }}
                                getItemString={(
                                  type,
                                  data,
                                  itemType,
                                  itemString
                                ) =>
                                  formatItemStringUObject(
                                    type,
                                    data,
                                    itemType,
                                    itemString
                                  )
                                }
                                keyPath={[selectKeyUObject(item)]}
                                shouldExpandNode={handleExpandNode}
                                labelRenderer={([key]) =>
                                  formatLabelUObject(key)
                                }
                                valueRenderer={(value) =>
                                  formatValueUObject(value)
                                }
                              />
                            </DialogContent>
                          </Dialog>
                        ) : null}
                      </TableCell>
                      <TableCell>
                        {safeGet(item, ["quality"], "")}
                      </TableCell>
                      <TableCell>
                        <Tooltip title={item.timestamp != null ? item.timestamp : ""} leaveDelay={500} interactive><span>{formatDate(true, item.timestamp)}</span></Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} dari ${count}`
                    }
                    labelRowsPerPage="Baris terlihat:"
                    rowsPerPageOptions={[25, 50, 100]}
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActionsWrapped}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        )}
      </SizeMe>
    </div>
  );
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
  };
};

export default connect(null, mapDispatchToProps)(TabLatest);
